import * as React from 'react';

import { NutanixLogoIcon } from 'common/components/core/icons';

import './LoaderCircle.scss';

/**
 * The Nutanix preloader.
 */
export default function LoaderCircle() {
  return (
    <div className="frame-loader" role="progressbar">
      <div className="frame-circle" />
      <div className="frame-line-mask">
        <div className="frame-loader-line" />
      </div>
      <NutanixLogoIcon className="loader-square" />
    </div>
  );
}
